"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userToken = exports.userSessionSelector = exports.userLogged = exports.userFeaturesSelector = exports.sessionSelector = exports.myPresenceSelector = exports.getWidgets = exports.getUserId = exports.getMyFirstname = exports.getDefaultTabBar = exports.getActivatedWidgets = exports._currentClientSelector = void 0;
var _constants = require("./constants");
var sessionSelector = state => state.session;
exports.sessionSelector = sessionSelector;
var userSessionSelector = state => {
  var _sessionSelector;
  return (_sessionSelector = sessionSelector(state)) === null || _sessionSelector === void 0 ? void 0 : _sessionSelector.user;
};
exports.userSessionSelector = userSessionSelector;
var _currentClientSelector = state => sessionSelector(state)._client;
exports._currentClientSelector = _currentClientSelector;
var getDefaultTabBar = state => sessionSelector(state).defaultTabBarName;
exports.getDefaultTabBar = getDefaultTabBar;
var getMyFirstname = state => {
  var _userSessionSelector;
  return (_userSessionSelector = userSessionSelector(state)) === null || _userSessionSelector === void 0 ? void 0 : _userSessionSelector.firstname;
};
exports.getMyFirstname = getMyFirstname;
var getUserId = state => {
  var _userSessionSelector2;
  return (_userSessionSelector2 = userSessionSelector(state)) === null || _userSessionSelector2 === void 0 ? void 0 : _userSessionSelector2.id;
};
exports.getUserId = getUserId;
var getWidgets = state => sessionSelector(state).dashboardWidgets;
exports.getWidgets = getWidgets;
var getActivatedWidgets = state => {
  var widgets = getWidgets(state) || [];
  return widgets.filter(widget => widget.state !== _constants.WIDGETS_STATES.NEVER);
};
exports.getActivatedWidgets = getActivatedWidgets;
var myPresenceSelector = state => {
  var _userSessionSelector3;
  return (_userSessionSelector3 = userSessionSelector(state)) === null || _userSessionSelector3 === void 0 ? void 0 : _userSessionSelector3.status;
};
exports.myPresenceSelector = myPresenceSelector;
var userLogged = state => !!sessionSelector(state).token;
exports.userLogged = userLogged;
var userToken = state => sessionSelector(state).token;
exports.userToken = userToken;
var userFeaturesSelector = state => {
  var _userSessionSelector4;
  return (_userSessionSelector4 = userSessionSelector(state)) === null || _userSessionSelector4 === void 0 ? void 0 : _userSessionSelector4.features;
};
exports.userFeaturesSelector = userFeaturesSelector;